// @flow

const number = (errorMessage: string) => (value: string | number): ?string => {
  if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) { // eslint-disable-line no-restricted-globals
    return undefined;
  }

  return errorMessage || 'Not a number';
};

export default number;
